import React from "react";



/**

 * Fond photo visible — overlay minimal (lisibilité via blocs GSD, pas voile sombre).

 * @param {{

 *   background: { id: string, src: string },

 *   isAdmin?: boolean,

 *   fading?: boolean,

 *   children: React.ReactNode,

 * }} props

 */

export function KarateBackgroundShell({ background, isAdmin = false, fading = false, children }) {

  return (

    <div

      className={`karate-bg-shell${isAdmin ? " karate-bg-shell--admin" : ""}${fading ? " karate-bg-shell--fading" : ""}`}

      data-testid="karate-background-shell"

      data-background-id={background.id}

      data-overlay-mode="minimal"

    >

      <div

        className="karate-bg-layer"

        style={{ backgroundImage: `url(${background.src})` }}

        aria-hidden="true"

        data-testid="karate-background-layer"

      />

      <div className="karate-bg-content">{children}</div>

    </div>

  );

}

